/**
 * Pure validation for the intent-resolve dialog's note field (Phase 2). The server requires a
 * non-blank note between 1 and 500 chars (this is the business record of why a human overrode the
 * sweep's own account of what happened) and 422s a blank one — mirrored here so the operator sees the
 * problem before a round trip, same reasoning as renewValidation.ts's client-side gates.
 */
import type { PoolIntentAction } from "@/api/types";
import type { TKey } from "@/i18n/keys";

export const RESOLVE_NOTE_MAX = 500;

/** Returns a translation key for the first violation, or null when the note is valid. */
export function validateResolveNote(note: string): TKey | null {
  const trimmed = note.trim();
  if (!trimmed) return "pool.intents.validation.noteRequired";
  if (trimmed.length > RESOLVE_NOTE_MAX) return "pool.intents.validation.noteTooLong";
  return null;
}

/** A small, statically-known enum → its i18n key — same reasoning as PeriodModal's ACTION_LABEL_KEY
 *  (a `Record` literal, not a template-built key, so every value is compile-checked). */
export const INTENT_ACTION_LABEL_KEY = {
  "license.remove": "pool.intents.actionLicenseRemove",
  "user.unlink": "pool.intents.actionUserUnlink",
} as const satisfies Record<PoolIntentAction, TKey>;
